import React from "react"
import '../style/common.css'
import WebApp from "../utils/WebAppPolyfill";
import { postFormData } from "../network/request"

// 导入 BaoBounty 主题图片
import mascotImg from "../assets/xxxx/BaoBounty_main_mascot_character_cute_round_steame-1776448209781.png"
import jobSeekerImg from "../assets/xxxx/BaoBounty_job_seeker_illustration_cute_bao_bun_ma-1776448110005.png"
import recruiterImg from "../assets/xxxx/BaoBounty_recruiter_illustration_cute_bao_bun_mas-1776448106306.png"

class WelcomPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            currentSlide: 0,
            slideList: [
                { id: 1, img: mascotImg, title: "Welcome to BaoBounty", subtitle: "Your career companion inside Telegram" },
                { id: 2, img: jobSeekerImg, title: "Find Your Dream Job", subtitle: "Discover opportunities that match your skills" },
                { id: 3, img: recruiterImg, title: "Hire the Best Talent", subtitle: "Connect with qualified candidates fast" }
            ],
            touchStartX: 0,
            touchEndX: 0
        }
        this.carouselRef = React.createRef()
    }

    componentDidMount() {
        this.requestFetchUser()
    }

    // 触摸开始
    handleTouchStart = (e) => {
        this.setState({
            touchStartX: e.touches[0].clientX
        })
    }

    // 触摸移动
    handleTouchMove = (e) => {
        this.setState({
            touchEndX: e.touches[0].clientX
        })
    }

    // 触摸结束
    handleTouchEnd = () => {
        const { touchStartX, touchEndX, currentSlide, slideList } = this.state
        const swipeThreshold = 50 // 最小滑动距离

        if (touchStartX - touchEndX > swipeThreshold) {
            // 向左滑动，切换到下一张
            if (currentSlide < slideList.length - 1) {
                this.goToSlide(currentSlide + 1)
            }
        } else if (touchEndX - touchStartX > swipeThreshold) {
            // 向右滑动，切换到上一张
            if (currentSlide > 0) {
                this.goToSlide(currentSlide - 1)
            }
        }
    }

    // 跳转到指定页面
    goToSlide = (index) => {
        this.setState({ currentSlide: index })
    }

    requestFetchUser = () => {
        const formData = new FormData()

        const initData = WebApp.initDataUnsafe
        if (!initData || !initData.user) {  // 如果没有用户数据，使用测试数据
            const testUser = {
                id: `user_${Date.now()}`,
                first_name: "Test",
                last_name: "User",
                username: "testuser",
                photo_url: "",
                language_code: "en",
                is_bot: false
            }
            localStorage.setItem("initUser", JSON.stringify(testUser))
        }else {
            localStorage.setItem("initUser", JSON.stringify(initData.user))
        }

        var initUser = JSON.parse(localStorage.getItem("initUser"));
        
        // Web环境下进行测试
        var userId = initUser.id // 如果没有用户ID，生成一个临时ID
        if (userId == 0) {
            initUser.id = `user_${Date.now()}`;
            localStorage.setItem("initUser", JSON.stringify(initUser));
            userId = initUser.id;
        }

        formData.append("userId", userId)
        formData.append("firstName", initUser.first_name || "nihao")
        formData.append("lastName", initUser.last_name || "nihao")
        formData.append("userName", initUser.username || "nihao")
        formData.append("photoUrl", initUser.photo_url || "nihao")
        formData.append("languageCode", initUser.language_code || "nihao")

        if (initUser.is_bot !== undefined) {
            formData.append("isBot", initUser.is_bot)
        }

        postFormData("/fetchUser", formData)
            .then(response => {
                if (response && response.success === true && response.data) {
                    localStorage.setItem("initUser", JSON.stringify(response.data))
                }
            })
            .catch(error => {
                console.error("数据提交失败:", error)
            })
    }

    render() {
        const { currentSlide, slideList } = this.state
        const isLastSlide = currentSlide === slideList.length - 1

        return (
            <div className="welcomeBGV">
                {/* 轮播图区域 */}
                <div
                    className="carouselContainer"
                    ref={this.carouselRef}
                    onTouchStart={this.handleTouchStart}
                    onTouchMove={this.handleTouchMove}
                    onTouchEnd={this.handleTouchEnd}
                >
                    <div
                        className="carouselTrack"
                        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                    >
                        {slideList.map((slide, index) => (
                            <div key={slide.id} className="carouselSlide">
                                <img src={slide.img} className="carouselImg" alt={`Slide ${index + 1}`} />
                                <div className="carouselContent">
                                    <p className="carouselTitle">{slide.title}</p>
                                    <p className="carouselSubtitle">{slide.subtitle}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* 指示器 */}
                    <div className="carouselIndicators">
                        {slideList.map((_, index) => (
                            <div
                                key={index}
                                className={`indicator ${index === currentSlide ? 'active' : ''}`}
                                onClick={() => this.goToSlide(index)}
                            />
                        ))}
                    </div>
                </div>

                {/* Start 按钮 - 只在最后一页显示 */}
                {isLastSlide && (
                    <div className="startBtn" onClick={this.props.onClick}>
                        <p className="startL">Start</p>
                    </div>
                )}
            </div>
        )
    }
}

export default WelcomPage
